<template>
    <v-container fluid>
        <v-row v-show="populating == false && populatingFailure == false">
            <v-col
                    cols="12"
                    md="6"
            >
                <v-card>
                    <v-form
                            ref="brokerForm"
                            v-model="isValid"
                    >
                        <v-card-text>
                            <v-container
                                    class="pb-0"
                                    fluid
                            >
                                <v-row class="pb-0">

                                    <v-col cols="12">
                                        <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule, lengthRule(50)]"
                                                label="Name"
                                                v-model="broker.name"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-text-field
                                                :disabled="isLoading"
                                                :rules="[requiredRule]"
                                                label="Comission Rate %"
                                                min="0"
                                                type="number"
                                                v-model.number="broker.comissionRate"
                                        ></v-text-field>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-file-input
                                                :disabled="isLoading"
                                                accept="image/png, image/jpeg, image/bmp, application/pdf"
                                                label="Contract Document"
                                                placeholder="Set Contract Document"
                                                ref="contractDocumentFileInput"
                                                v-model="contract"
                                        >
                                            <template slot="append-outer">
                                                <v-btn
                                                        @click.stop="
                                                                getFile(
                                                                    broker.contractFileId,
                                                                    'broker_' +
                                                                        broker.id +
                                                                        '_contract_' +
                                                                        broker.contractFileId
                                                                )
                                                            "
                                                        elevation="1"
                                                        fab
                                                        small
                                                        v-show="broker.contractFileId >0"
                                                >
                                                    <h3>
                                                        <v-icon color="light-blue">mdi-download</v-icon>
                                                    </h3>
                                                </v-btn>
                                            </template>
                                        </v-file-input>
                                    </v-col>

                                    <v-col cols="12">
                                        <v-select
                                                :disabled="isLoading"
                                                :items="brokerfirms"
                                                :rules="[requiredRule]"
                                                clearable
                                                item-text="value"
                                                item-value="key"
                                                label="Broker Firm"
                                                v-model="broker.brokerFirmId"
                                        ></v-select>
                                    </v-col>

                                </v-row>
                                <v-row
                                        align="end"
                                        class="pt-0"
                                        justify="space-between"
                                        no-gutters
                                >
                                    <v-btn
                                            :disabled="isLoading && !isDeleting"
                                            :loading="isDeleting"
                                            @click="deleteEntity"
                                            class="text-none"
                                            color="warning darken-1"
                                            text
                                            v-show="broker.id > 0"
                                    >Delete
                                    </v-btn>
                                    <v-spacer></v-spacer>
                                    <!--<v-btn
                                    :disabled="isLoading"
                                    @click="closeForm"
                                    class="text-none"
                                    color="secondary darken-1"
                                    text
                                    >Close</v-btn>-->
                                    <v-btn
                                            :disabled="isLoading && !isSaving"
                                            :loading="isSaving"
                                            @click="saveEntity"
                                            class="text-none"
                                            color="secondary darken-1"
                                            text
                                    >{{ broker.id > 0 ? "Update" : "Add" }}
                                    </v-btn>
                                </v-row>
                            </v-container>
                        </v-card-text>
                    </v-form>
                    <v-snackbar
                            :color="notifyColor"
                            :timeout="15000"
                            top
                            v-model="notifyShow"
                    >
                        {{ notifyMessage }}
                        <template v-slot:action="{ attrs }">
                            <v-btn
                                    @click="notifyShow = false"
                                    class="text-none"
                                    icon
                                    v-bind="attrs"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                    </v-snackbar>
                </v-card>
            </v-col>
            <v-col
                    cols="12"
                    md="6"
                    no-gutters
            >
                <v-col
                        cols="12"
                        v-show="broker.id > 0"
                >
                    <h3>
                        Notes
                        <v-btn
                                :disabled="isLoading"
                                @click="newNoteShow = true"
                                class="text-none ml-2"
                                color="secondary darken-1"
                                fab
                                x-small
                        >
                            <v-icon>mdi-plus</v-icon>
                        </v-btn>
                    </h3>
                    <v-col
                            :key="note.id"
                            cols="12"
                            justify="start"
                            no-gutters
                            v-for="note in broker.brokerNotes"
                    >
                        <v-card>
                            <v-card-subtitle>
                                {{ note.author }}
                                <br/>
                                {{ note.createdAt }}
                            </v-card-subtitle>
                            <v-card-text>{{ note.text }}</v-card-text>
                        </v-card>
                    </v-col>
                </v-col>
            </v-col>
            <v-dialog
                    persistent
                    v-model="newNoteShow"
                    width="500px"
            >
                <v-card>
                    <v-card-title></v-card-title>
                    <v-card-text>
                        <v-textarea
                                :rules="[lengthRule(512)]"
                                counter
                                label="Note"
                                v-model="newNoteText"
                        ></v-textarea>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                @click="
              () => {
                newNoteShow = false;
                newNoteText = '';
              }
            "
                                class="text-none"
                                color="secondary darken-1"
                                text
                        >Close
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                                :disabled="isLoading || newNoteAdding || newNoteText.length == 0"
                                :loading="newNoteAdding"
                                @click="newNoteAdd"
                                class="text-none"
                                color="secondary darken-1"
                                text
                        >Add
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-row>
        <v-row v-show="populating == true">
            <v-col
                    class="text-center"
                    cols="12"
            >
                <v-progress-circular
                        :size="50"
                        color="secondary"
                        indeterminate
                ></v-progress-circular>
            </v-col>
        </v-row>
        <v-row v-show="populating == false && populatingFailure == true">
            <v-col
                    class="text-center"
                    cols="12"
            >Could not load the form. Please refresh the page and try again. If the issue persists contact support.
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import Broker from "../../models/Broker.model";
import uuid4 from "../../helpers/uuid4";

export default {
    props: {
        brokerId: {
            type: Number,
            default: 0
        },
    },
    components: {
        //
    },
    created: async function () {
        //
    },
    mounted: async function () {
        this.brokerfirms = await this.$store.dispatch("brokerfirms/getlist");
        await this.load();
    },
    data() {
        return {
            brokerIdValue: this.brokerId,
            populating: true,
            populatingFailure: true,
            requestId: uuid4(),
            broker: {},
            brokerIn: {},
            brokerfirms: [],
            isValid: null,
            isLoading: null,
            isSaving: null,
            isDeleting: null,
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,
            requiredRule: v => !!v || "required",
            lengthRule: limit => v =>
                !v || v.length <= limit || "exceeds " + limit + " characters",
            emailRule: v => /.+@.+$/.test(v) || "invalid email",
            contract: null,

            newNoteShow: null,
            newNoteAdding: false,
            newNoteText: "",
        };
    },
    computed: {
        //
    },
    methods: {
        clearUploadInputs() {
            this.contract = null;
        },
        async load() {
            this.populating = true;
            this.populatingFailure = true;

            if (this.brokerIdValue > 0) {
                var requestId = (this.requestId = uuid4());
                var brokerResponse = await this.$store.dispatch(
                    "brokers/get",
                    {
                        id: this.brokerIdValue,
                        urlParameters: {},
                        requestId: requestId
                    }
                );
                if (
                    this.requestId == brokerResponse.requestId &&
                    brokerResponse.data.total == 1 &&
                    brokerResponse.data.page[0].id ==
                    this.brokerIdValue
                ) {
                    this.clearUploadInputs();
                    this.brokerIn = brokerResponse.data.page[0];
                    this.broker = new Broker().set(this.brokerIn);
                    this.populatingFailure = false;
                }
            } else if (this.brokerIdValue === 0) {
                this.broker = new Broker();
                this.populatingFailure = false;
            }
            this.populating = false;
        },

        newNoteAdd() {
            this.isLoading = true;
            this.newNoteAdding = true;
            this.$store
                .dispatch("brokers/addNote", {
                    brokerId: this.broker.id,
                    text: this.newNoteText
                })
                .then(
                    response => {
                        this.broker.brokerNotes.push({
                            id: response.id,
                            author: response.author,
                            text: response.text,
                            createdAt: response.createdAt
                        });
                        this.emitSavedEntity(null);
                        this.newNoteAddingDone();
                        this.newNoteShow = false;
                        this.newNoteText = "";
                    },
                    error => this.notify(error.response.data, "error")
                )
                .finally(this.newNoteAddingDone);
        },
        newNoteAddingDone() {
            this.newNoteAdding = false;
            this.isLoading = false;
        },

        //emitters      ------------------------------------------------------------
        emitSavedEntity(savedBroker) {
            this.$emit("saved", savedBroker);
        },
        emitDeletedEntity(deletedBroker) {
            this.$emit("deleted", deletedBroker);
        },
        emitCloseForm() {
            this.$emit("close");
        },
        //general       ------------------------------------------------------------
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        closeForm() {
            this.notifyShow = false;
            this.emitCloseForm();
        },
        validateForm() {
            this.isValid = this.$refs.brokerForm.validate();
            return this.isValid;
            /*
            if (!(this.broker.driverIdentityId > 0))
                this.broker.driverIdentityId = 0;

            if (this.isValid) return this.broker.driverIdentityId > 0;
            else return false;
            */
        },

        //save      ------------------------------------------------------------
        async saveEntity() {
            if (this.validateForm()) {
                this.isLoading = true;
                this.isSaving = true;

                var formdata = new FormData();
                formdata.append("ContractFile", this.contract);
                formdata.append("Model", JSON.stringify(this.broker));

                const parameters = {
                    id: this.broker.id,
                    formData: formdata
                };
                var hasId = this.broker.id > 0;
                try {
                    var broker = await this.$store.dispatch(
                        "brokers/" + (hasId ? "update" : "create"),
                        hasId ? parameters : parameters.formData
                    );
                    this.notify("Broker successfully saved.", "success");
                    if (!(this.broker.id > 0)) {
                        this.broker.id = broker.id;
                        this.brokerIdValue = this.broker.id;
                    }
                    this.emitSavedEntity(broker);
                    await this.load();
                } catch (e) {
                    this.notify(e.response.data, "error");
                }
                this.saveEntityDone();
            }
        },
        saveEntityDone() {
            this.isLoading = false;
            this.isSaving = false;
        },
        //delete        ------------------------------------------------------------
        deleteEntity() {
            var isConfirmed = confirm(
                "Are you sure you want to delete this broker?"
            );
            if (isConfirmed) {
                this.isLoading = true;
                this.isDeleting = true;
                this.$store
                    .dispatch("brokers/delete", this.broker.id)
                    .then(
                        () => {
                            this.notify(
                                "Broker successfully deleted.",
                                "success"
                            );
                            this.emitDeletedEntity(this.broker);
                            this.closeForm();
                        },
                        error => this.notify(error.response.data, "error")
                    )
                    .finally(this.deleteEntityDone);
            }
        },
        deleteEntityDone() {
            this.isLoading = false;
            this.isDeleting = false;
        },
        getFile(fileId, namePrefix) {
            this.$store.dispatch("files/get", {
                fileId: fileId,
                namePrefix: namePrefix
            });
        },
    }
};
</script>

<style lang="stylus" scoped></style>
